module.exports = __webpack_public_path__ + "static/media/background.990809d6.svg";